import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

const baseStyles = style({
  borderRadius: vars.radii.xs,
  padding: `0.2rem ${vars.space.m}`,
  textAlign: "center",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const fdrStyles = styleVariants({
  1: [baseStyles, vars.colors.difficulties[1]],
  2: [baseStyles, vars.colors.difficulties[2]],
  3: [baseStyles, vars.colors.difficulties[3]],
  4: [baseStyles, vars.colors.difficulties[4]],
  5: [baseStyles, vars.colors.difficulties[5]],
});
